<template>
  <div class="dialog-container wt-dialog-container">
    <div v-loading="isIntegralRulesDetailLoading">
      <wt-detail-form-section ref="formSection" :detail-form-data.sync="detailFormData" :detail-form.sync="detailForm" />
      <wt-detail-form-buttons :detail-form-buttons.sync="detailFormButtons" @on-detail-button-action="onDetailButtonAction"></wt-detail-form-buttons>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'IntegralPointsEdit',
  props: ['component-type'],
  isAutoComponent: true,
  data() {
    return {
      formCode: 'MODULES_USERINTEGRALDETAILS',
      isSubmitLoading: false,
      formUpdateUrl: '/modules/integralRules/integralRulesUpdate',
      formAddUrl: '/modules/integralRules/integralRulesUpdate',
      detailFormButtons: {
        title: '积分项设置',
        elements: [{ name: '提交', key: 'ADD', action: 'ADD', className: 'primary', hidden: this.componentType !== 'add' },
          { name: '提交', key: 'EDIT', action: 'EDIT', className: 'primary', hidden: this.componentType !== 'edit' },
          { name: '返回', key: 'CLOSE', action: 'CLOSE' }]
      },
      detailForm: {
        title: '基本信息',
        elements: [
          { name: '标题', key: 'name', type: 'text', required: true, disabled: false },
          { name: '积分', key: 'rewardIntegral', type: 'text', required: true, disabled: false }]
      }
    }
  },
  created() {
  },
  methods: {
    /*  ------------------------- 按钮  -------------------------  */
    onDetailButtonAction(item) {
      if (item.action === 'CLOSE') {
        this.$emit('on-dialog-action', 'close')
      } else if (item.action === 'ADD') {
        this.onAdd()
      } else if (item.action === 'EDIT') {
        this.onSave()
      }
    },
    onAdd() {
      const that = this
      this.$wtUtil.validateDetailFormsAndConfirm(this, '是否提交').then(() => {
        that.requestAddUserIntegralDetailsDetail()
      }).catch(() => {
      })
    },
    onSave() {
      const that = this
      this.$wtUtil.validateDetailFormsAndConfirm(this, '是否提交').then(() => {
        that.requestUpdateUserIntegralDetailsDetail()
      }).catch(() => {
      })
    },
    /*  ------------------------- 网络请求  -------------------------  */
    requestAddUserIntegralDetailsDetail() {
      const that = this
      this.$wtUtil.postFormData({
        url: this.formAddUrl,
        formData: this.detailFormData,
        isLoading: this.isSubmitLoading
      }).then(resp => {
        that.$message({ message: '保存成功', type: 'success' })
        that.$emit('on-dialog-action', 'close')
        that.$emit('on-dialog-action', 'refresh')
      })
    },
    requestUpdateUserIntegralDetailsDetail() {
      const that = this
      this.$wtUtil.postFormData({
        url: this.formUpdateUrl,
        formData: this.detailFormData,
        isLoading: this.isSubmitLoading
      }).then(resp => {
        that.$message({ message: '保存成功', type: 'success' })
        that.$emit('on-dialog-action', 'close')
        that.$emit('on-dialog-action', 'refresh')
      })
    },
    onWtDialogClose() {
      this.$emit('on-dialog-action', 'close')
    }
  },
  computed: {
    ...mapState({
      isIntegralRulesDetailLoading: state => state.integralRules.isIntegralRulesDetailLoading,
      detailFormData: state => state.integralRules.integralRulesDetailData
    })
  }
}
</script>

<style scoped>

</style>
